<template>
  <!-- <div class="fix__top__right"> -->
  <div class="w-100">
    <p
      class="d-flex align-items-center grey-on-hover mb-0 py-1"
      key="nm-closed"
      @click="openNotifications"
      @keydown.enter.prevent="openNotifications"
      @keydown.space.prevent="openNotifications"
      role="button"
      tabindex="0"
      :aria-label="$t('NotificationCenter.open_panel')"
      style="
        white-space: nowrap;
        flex-shrink: 0;
        text-overflow: clip;
        overflow-x: hidden;
      "
    >
      <b-iconstack aria-hidden="true" font-scale="1.3" class="point ml-1" >
        <b-icon stacked icon="circle-fill" variant="white" scale="0.6"></b-icon>
        <b-icon stacked icon="bell-fill" scale="0.8" variant="white"></b-icon>
        <b-icon stacked icon="bell" scale="0.8" variant=""></b-icon>
        <b-icon stacked icon="circle" scale="1.05" variant=""></b-icon>
      </b-iconstack>
      <b-badge
        v-show="msgCount > 0"
        class="align-self-start notification__count"
        variant="danger"
        >{{ msgCount }}
      </b-badge>
      <span class="mb-0 ml-2 point">{{ $t('NotificationCenter.title') }}</span>
    </p>
    <!-- Pannello laterale delle notifiche (.notif-panel in _chrome.scss §11) -->
    <transition name="fade">
      <div v-if="isOpen" class="notif-panel" key="nm-opened">
        <div class="notif-panel__backdrop" @click="isOpen = false" aria-hidden="true"></div>
        <aside
          class="notif-panel__sheet"
          role="dialog"
          aria-modal="true"
          :aria-label="$t('NotificationCenter.title')"
        >
          <header class="notif-panel__head">
            <h2 class="notif-panel__title">{{ $t('NotificationCenter.title') }} {{ msgCountText }}</h2>
            <b-button
              variant="white"
              class="btn-icon btn-sm"
              @click="isOpen = false"
              :aria-label="$t('NotificationCenter.close_panel')"
            >
              <b-icon icon="x-lg" aria-hidden="true"></b-icon>
            </b-button>
          </header>
          <div class="notif-panel__body">
            <div
              v-for="(msg, ind) in messages"
              :key="ind"
              class="list-row notif-panel__item notif-panel__item--new"
            >
              <span class="list-row__icon" aria-hidden="true"><b-icon icon="bell-fill"></b-icon></span>
              <div class="list-row__body">
                <p class="list-row__title mb-0">{{ msg.title }}</p>
                <p class="list-row__meta mb-0">{{ msg.body }}</p>
              </div>
            </div>
            <div
              v-for="(msg, ind) in readMessages"
              :key="'r-' + ind"
              class="list-row notif-panel__item"
            >
              <span class="list-row__icon" aria-hidden="true"><b-icon icon="bell"></b-icon></span>
              <div class="list-row__body">
                <p class="list-row__title mb-0">{{ msg.title }}</p>
                <p class="list-row__meta mb-0">{{ msg.body }}</p>
                <p class="list-row__meta mb-0" v-if="msg.extraData">{{ msg.extraData }}</p>
              </div>
            </div>
            <template v-if="noTokenMsg">
              <p key="empty-list" class="list-row__empty">{{ $t('NotificationCenter.browserPermission') }}</p>
            </template>
            <template v-else-if="msgCount == 0 && readMessages.length == 0">
              <p key="empty-list" class="list-row__empty">{{ $t('NotificationCenter.noNotifications') }}</p>
            </template>
          </div>
        </aside>
      </div>
    </transition>
  </div>

  <!-- </div> -->
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getAuth, onAuthStateChanged, getRedirectResult } from "firebase/auth";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import { cittadinoService } from "@/_services";
export default {
  name: "NotificationCenter",
  data() {
    return {
      token: null,
      messages: [],
      readMessages: [],
      isOpen: false,
      noTokenMsg: false,
      attempts: 0,
      notificationLogCounter: 0, // Contatore per tracking duplicati
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
    msgCount: function () {
      const count = this.messages.length;
      return count;
    },
    msgCountText: function () {
      const text = this.msgCount > 0 ? ` (${this.msgCount})` : "";
      return text;
    },
  },
  watch: {
    token: function (now, prev) {
      if (now) {
        this.storeToken();
      }
    },
    messages: {
      handler: function(newMessages, oldMessages) {
      },
      deep: true
    },
    readMessages: {
      handler: function(newMessages, oldMessages) {
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    openNotifications() {      
      this.isOpen = true;
      var self = this;
      setTimeout(function () {        
        var prev = self.readMessages;
        self.readMessages = self.messages.concat(prev);
        self.messages = [];
      }, 1000);
    },
    firebaseAuth() {
      const auth = getAuth(this.$root.firebaseApp);
      onAuthStateChanged(auth, (user) => {
      });
    },
    storeToken() {
      var form = {
        token: this.token,
        client: "web",
      };
      
      var self = this;
      cittadinoService
        .storeFirebaseToken(form)
        .then(function (res) {
        })
        .catch(function (err) {
          console.error("💾 [storeToken] Error storing token:", err);
          self.initPushWithTimeout();
        });
    },
    async messagingInit() {
      var self = this;
      try {
        // Verifica supporto Service Worker
        if (!('serviceWorker' in navigator)) {
          self.noTokenMsg = true;
          return;
        }
        
        // Scope del service worker
        const scopePath = "/" + process.env.VUE_APP_SCOPE + "/";
        const registration = await navigator.serviceWorker.getRegistration(scopePath);
        
        if (!registration) {
          const allRegistrations = await navigator.serviceWorker.getRegistrations();
          self.noTokenMsg = true;
          return;
        }
        
        if (registration.active && !navigator.serviceWorker.controller) {

          try {
            await registration.update();
          } catch (updateErr) {
          }

          const controllerPromise = new Promise((resolve) => {
            if (navigator.serviceWorker.controller) {
              resolve(navigator.serviceWorker.controller);
              return;
            }
            navigator.serviceWorker.addEventListener(
              'controllerchange',
              () => {
                if (navigator.serviceWorker.controller) {
                  resolve(navigator.serviceWorker.controller);
                }
              },
              { once: true }
            );
          });

          const readyPromise = navigator.serviceWorker.ready
            .then((readyReg) => {
              return readyReg.active || navigator.serviceWorker.controller;
            })
            .catch(() => null);

          const timeoutPromise = new Promise((resolve) => setTimeout(resolve, 5000));

          const controller = await Promise.race([
            controllerPromise,
            readyPromise,
            timeoutPromise,
          ]);
        }
        
        // Verifica che il SW sia effettivamente attivo
        if (!registration.active) {
          console.error("🚀 [messagingInit] Service Worker is NOT active");
          self.noTokenMsg = true;
          return;
        }

        // Inizializza Firebase Messaging
        const messaging = getMessaging(this.$root.firebaseApp);
        
        var vapkey = process.env.VUE_APP_FBS_VAPIDKEY;
        
        if (!vapkey) {
          console.error("🚀 [messagingInit] No VAPID key found");
          self.noTokenMsg = true;
          return;
        }
        
        getToken(messaging, {
          vapidKey: vapkey,
          serviceWorkerRegistration: registration,
        })
          .then((currentToken) => {
            if (currentToken) {
              self.token = currentToken;
              self.noTokenMsg = false;
            } else {
              console.warn("🚀 [messagingInit] No token obtained (permission denied?)");
              self.noTokenMsg = true;
            }
          })
          .catch((err) => {
            console.error("🚀 [messagingInit] Error retrieving token:", err);
            self.noTokenMsg = true;
          });

        // Handler per messaggi in foreground (quando l'app è aperta)
        onMessage(messaging, (payload) => {
          self.notificationLogCounter++;
        
          if (payload.notification) {
            self.addMessage(payload.notification);
          } else if (payload.data) {
            self.addMessage(payload.data);
          }
        });
      } catch (err) {
        console.error("🚀 [messagingInit] Exception during initialization:", err);
        console.error("🚀 [messagingInit] Error stack:", err.stack);
        self.noTokenMsg = true;
      }
    },
    addMessage(data) {
      this.notificationLogCounter++;
      this.messages.splice(0, 0, data);

      this.$bvToast.toast(data.body, {
        title: data.title,
        solid: true,
        variant: "primary",
      });
      // this.infoAlert("Nuova notifica");
    },
    initPushWithTimeout() {
      
      if (this.attempts > 3) {
        console.warn("⏳ [initPushWithTimeout] Max attempts reached (3), stopping");
        return false;
      }
      
      var self = this;
      setTimeout(function () {
        isSupported().then((supported) => {
          if (supported) {
            self.attempts++;
            self.messagingInit();
          } else {
            console.warn("⏳ [initPushWithTimeout timeout] Firebase Messaging NOT supported");
          }
        });
      }, 3000);
    },
  },
  created() {
    isSupported().then((supported) => {
      if (supported) {
        this.firebaseAuth();
      } else {
        console.warn("🎬 [created] Firebase Messaging NOT supported, skipping auth");
      }
    });
  },
  mounted() {    
    this.initPushWithTimeout();
    
    // navigator.serviceWorker.addEventListener("message", (event) => {
    //   self.notificationLogCounter++;
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Message received from Service Worker");
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] event.data:", JSON.stringify(event.data, null, 2));
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Stack trace:", new Error().stack);
    //   
    //   var payload = event.data;
    //   if (event.data.data) {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Using event.data.data");
    //     payload = event.data.data;
    //   } else if (event.data.notification) {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Using event.data.notification");
    //     payload = event.data.notification;
    //   }
    //   
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Final payload:", JSON.stringify(payload, null, 2));
    //   
    //   // Verifica che il payload contenga dati validi prima di mostrare la notifica
    //   if (payload && (payload.title || payload.body)) {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Calling addMessage");
    //     this.addMessage(payload);
    //   } else {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Payload invalid, NOT calling addMessage");
    //   }
    // });
  },
};
</script>
<style lang="scss">
.notification__count {
  margin-left: -0.5rem;
  margin-bottom: 1rem;
}
</style>
